import { Tooltip } from '@odo/shared-ui';
import type { PriorityLevel } from './priority.js';
import { ExtremeGlyph } from './PriorityGlyphs.js';
import { PRIORITY_PILL_BASE, PRIORITY_PILL_TONES } from './priorityTones.js';

interface PriorityPillProps {
    priority: PriorityLevel;
    /** When provided, the pill renders as a button (detail-panel selector); otherwise it is display-only. */
    onClick?: (e: React.MouseEvent) => void;
}

export function PriorityPill({ priority, onClick }: PriorityPillProps) {
    // Normal carries no badge anywhere — the quiet majority by design.
    if (priority === 'normal') return null;

    const classes = `${PRIORITY_PILL_BASE} ${PRIORITY_PILL_TONES[priority]}`;
    const label = priority === 'high' ? 'High' : 'Extreme';
    const content =
        priority === 'high' ? (
            <>
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500" aria-hidden="true" />
                High
            </>
        ) : (
            <>
                <ExtremeGlyph className="text-white" />
                Extreme
            </>
        );

    if (onClick) {
        return (
            <Tooltip content={`Priority: ${label} — click to change`}>
                <button type="button" onClick={onClick} className={`${classes} cursor-pointer`}>
                    {content}
                </button>
            </Tooltip>
        );
    }

    return (
        <Tooltip content={`Priority: ${label}`}>
            <span className={classes}>{content}</span>
        </Tooltip>
    );
}
